module.exports = __webpack_public_path__ + "img/bi_bg-2df70eb6d9c685fa0feca23b33a5ea7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/bi_bg.png
// module id = 390
// module chunks = 134